import { Command } from 'commander'

import { version, bin } from '../package.json'
import domains from './domains'

export const getProgram = () => {
  const program = new Command()

  program
    .name(Object.keys(bin)[0])
    .description('CLI to work with your OpenAPI files')
    .version(version)

  /** display help in case of error */
  program.showHelpAfterError()

  // Register all domains
  domains.forEach((domain) => program.addCommand(domain))

  return program
}
